import { Button, SxProps, Theme } from '@mui/material';

interface IProps {
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  startIcon?: React.ReactNode;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  type?: 'button' | 'reset' | 'submit' | undefined;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  href?: string;
}

export function SnackbarButton({
  children,
  onClick,
  startIcon,
  disabled = false,
  sx,
  type,
  color = 'secondary',
  href,
}: IProps) {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      disabled={disabled}
      sx={{
        borderRadius: '50px',
        textTransform: 'none',
        paddingRight: '14px',
        paddingLeft: '14px',
        fontSize: '12px',
        height: '25px',
        fontWeight: 'bold',
        ...sx,
      }}
      startIcon={startIcon}
      type={type || 'button'}
      color={color}
      href={href}
    >
      {children}
    </Button>
  );
}

export function buildSnackbarButton(title: string, onClick: () => void) {
  return <SnackbarButton onClick={onClick}>{title}</SnackbarButton>;
}
